<template>
  <article
    class="form_modal"
    v-if="active_modal">
    <section class="form_modal__container">
      <h1 class="modal_headline_normal__title">{{ action === 'new' ? 'Crear nuevo Titular' : 'Editar Titular' }} </h1>
      <v-flex xs12>
        <span class="table_card__info--label">Título</span>
        <input
          class="faccess_input"
          type="text"
          :style="news.attributes.name.length<=0&&activeErrorName?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
          name="Name"
          @blur="activeErrorName=true"
          placeholder="Título de la noticia"
          v-model="news.attributes.name">
      </v-flex>
      <v-flex xs12>
        <span class="table_card__info--label">Fecha de titular</span>
        <app-single-date-picker
          :solid="false"
          :clases="false"
          :date="date_text_select"
          v-model="news.attributes.publication_date"
          @filterQuery="changeDate($event)"
        >
        </app-single-date-picker>
      </v-flex>
      <v-flex xs12>
        <span style="display: block; margin-top: 30px;"
        class="table_card__info--label">Sedes</span>
        <v-select
          label="Selecciona"
          v-bind:items="locationslist"
          :item-text="'attributes.name'"
          :item-value="'id'"
          v-model="news.attributes.location_id"
          single-line
          bottom
          solo
          color="#1476FB"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <span class="table_card__info--label">Fecha de vencimiento</span>
        <app-single-date-picker :solid="false" @filterQuery="changeExpirationDate($event)"></app-single-date-picker>
      </v-flex>

      <v-flex xs12>
        <v-switch
          class="data_card_special__switch"
          :label="`Visible para los usuarios`"
          color="#1476FB"
          v-model="news.attributes.visible_to_user">
        </v-switch>
      </v-flex>
      <div class="modal_headline_normal__buttons">
        <button
          @click="handleCancel"
          class="modal_headline_normal__buttons--closed"> Cerrar</button>
        <button v-if="action === 'new'"
          style="color: #1476FB"
          @click="formIsInError?'':createNews()">Agregar
        </button>
        <button
          v-if="action === 'edit'"
          style="color: #1476FB"
          @click="formIsInError?'':updateNews()">Actualizar
        </button>
      </div>
    </section>
  </article>
</template>

<script>

export default {
  props:['active_modal','id','action'],
  data(){
    return{
      charged: false,
      date_text_select: 'dd/mm/aaaa',
      news_types: ['Normal', 'Video','Titular'],
      manager_url_change: false,
      schedule_url_change: false,
      schedule_url: '',
      manager_url: '',
      photo_name: 'No se han seleccionado archivos',
      activeErrorName:false,
      locationslist: '',
      specialCategoriesList: '',
      fieldError:'',
      url_change: false,
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      news:{
        attributes:{
          special_category_id: '',
          location_id: '',
          name: '',
          publication_date: '',
          description: '',
          url: '',
          url_type: '',
          visible_to_user: true,
          news_type: 'Titular',
          video_published: false,
          expiration: null
        },
      },
    }
  },
  mounted(){
    console.log('#### action #### ',this.action)
    if(this.action === 'new'){
      this.charged = true
    }
    if(this.action === 'edit'){
      this.findNewsById()
    }
    this.findLocations()
  },
  watch:{
    url(){
      this.url_change = true;
    },
    schedule_url(){
      // cl schedule_url
      if(this.schedule_url != ''){
        this.schedule_url_change = true;
      }
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    }
  },
  computed:{
    formIsInError(){
      var ans=false
      let fields=[]
      if(this.news.attributes.name.length==0){
        fields.push("'Titulo'");
      }
      if(this.news.attributes.publication_date.length==0){
        fields.push("'Fecha de titular'")
      }
      if(this.scheduleIsInError){
        fields.push("''")
      }
      if(fields.length>0){
        if(fields.length==2){
          this.fieldError=fields.join(" y ")
        }else{
          this.fieldError=fields.join(" , ")
        }

        ans=true
      }else{
        this.fieldError=""
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },
  },
  methods:{
    changeExpirationDate(val){
      var vm = this
      vm.news.attributes.expiration = val
    },
    findLocations(){
      try {
        this.$http.get('app/locations',{
            params:{
            company:{id:this.getCompany().id
          },
            headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}}}
          )
        .then(function(response){
          this.locationslist = response.body.data
          console.log('this.locationslist ', this.locationslist)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      if (name_field=='schedule') {
        this.schedule_url = URL.createObjectURL(files[0]);
      }else if(name_field=='manager'){
        this.manager_url = URL.createObjectURL(files[0]);
      } else {
        this.url = URL.createObjectURL(files[0]);
      }
      this.createImage(files[0], ""+e.target.name)
    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {

        if (name_field=='schedule') {
          vm.news.attributes.schedule_image = reader.result
        }else if(name_field=='manager'){
          vm.news.attributes.manager_image = reader.result
        } else {
          //vm.location.attributes.image = reader.result
          vm.news.attributes.url = reader.result
        }
        vm.photo_name=name_field
        // vm.location.attributes.image = reader.result
      }
    },
    createNews(){
      this.news.attributes.video_published === false ? this.news.attributes.url_type = 'img' : this.news.attributes.url_type = 'video'

      try {
        this.$http.post('app/articles/create', { data: this.encrypt(this.news).toString() },
          {headers:
            {
             "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
        .then(function(response){
          console.log(response);
          this.$router.push({name: 'news_headline'})
          this.news.attributes.name = '';
          this.news.attributes.publication_date = '';
          this.handleCancel();
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        console.log(e);
        alert(e.message)
      }
    },
    handleCancel(){
      this.$emit('handleCancelNewsHeadline', false)
    },
    changeDate(val){
      // cl val
      this.news.attributes.publication_date = val
      this.date_text_select = val
    },
    updateNews(){
      try {
        this.$http.put('app/articles/update', { data: this.encrypt(this.news).toString() },
          { headers:
            {
             "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{
              id: this.id
            }
          })
        .then(function(response){
          console.log(response);
          this.$router.push({name: 'news_headline'})
          this.news.attributes.name = '';
          this.news.attributes.publication_date = '';
          this.handleCancel();
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        console.log(e);
        alert(e.message)
      }
    },
    findNewsById(){
      console.log('#### findNewsById ##### ')
      try {
        this.$http.get('app/articles/show', {
          params:{
            id: this.id
          },
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.news = response.body.data
          let f =  this.news.attributes.publication_date
          this.date_text_select = f.substring(8,10) + '/' + f.substring(5,7) + '/' + f.substring(0,4)
          this.charged=true
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },

  } //closed methods
}
</script>



// WEBPACK FOOTER //
// src/components/views/news/headline/Modal_new_edit_news.vue